import { render, staticRenderFns } from "./IconTags.vue?vue&type=template&id=7608f0e6&scoped=true&"
import script from "./IconTags.vue?vue&type=script&lang=js&"
export * from "./IconTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608f0e6",
  null
  
)

export default component.exports